export const OPENSEA_API_KEY = 'b5400021ebc9489a9fe8a4544f663b53';
